import { create } from 'zustand'
import { ItemsToBringListing } from 'types/listing/listings'

const itemsToBringCreationStore = (set: any) => ({
  addItemsToBringModal: false,
  setAddItemsToBringModal: (state: boolean) =>
    set(() => ({ addItemsToBringModal: state })),
  itemsToBringData: null,
  setItemsToBringData: (state: ItemsToBringListing) =>
    set(() => ({ itemsToBringData: state })),
})

export const itemsToBringStore = create(itemsToBringCreationStore)
